import { action } from 'satcheljs';

export const onAttachmentTreeRootNodeClicked = action(
    'ATTACHMENT_TREE_ROOT_NODE_CLICKED',
    (isExpanded: boolean) => ({
        isExpanded: isExpanded,
    })
);
